/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetOnboardingSnapshotQueryResponse, GetOnboardingSnapshotPathParams, GetOnboardingSnapshot400, GetOnboardingSnapshot401, GetOnboardingSnapshot403, GetOnboardingSnapshot404, GetOnboardingSnapshot409, GetOnboardingSnapshot500 } from "../../types/onboardingController/GetOnboardingSnapshot.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetOnboardingSnapshotUrl(organizationId: GetOnboardingSnapshotPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/onboarding/` as const }
  return res
}

/**
 * @summary Get the organization onboarding snapshot for the caller
 * {@link /api/organizations/:organizationId/onboarding/}
 */
export async function getOnboardingSnapshot(organizationId: GetOnboardingSnapshotPathParams["organizationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetOnboardingSnapshotQueryResponse, ResponseErrorConfig<GetOnboardingSnapshot400 | GetOnboardingSnapshot401 | GetOnboardingSnapshot403 | GetOnboardingSnapshot404 | GetOnboardingSnapshot409 | GetOnboardingSnapshot500>, unknown>({ method : "GET", url : getGetOnboardingSnapshotUrl(organizationId).url.toString(), ... requestConfig })
  return res.data
}